import Vue from 'vue'
import VueRouter from 'vue-router'

import home from '../views/new-home.vue'
// import flights from '../views/flights.vue'
// import flightResults from '../views/flightResults.vue'
// import book from '../views/book.vue'
// import register from '../views/register.vue'
// import verify from '../views/verify.vue'
// import login from '../views/login.vue'
// import resetPassword from '../views/resetPassword.vue'
// import profile from '../views/profile.vue'
// import hotelsResults from '../views/hotelsResults.vue'
// import hotels from '../views/hotels.vue'
// import oneHotel from '../views/oneHotel.vue'
// import hotelBook from '../views/hotelBook.vue'
// import cars from '../views/cars.vue'
// import carsResults from '../views/carsResults.vue'
// import carBook from '../views/carBook.vue'
// import mailBox from '../views/mailBox.vue'
// import trips from '../views/trips.vue'
// import trip from '../views/trip.vue'
// import terms from '../views/terms.vue'
// import privacy from '../views/privacy.vue'
// import help from '../views/help.vue'
// import rewards from '../views/rewards.vue'
// import about from '../views/about.vue'
import empty from '../components/404.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/flights',
  //   name: 'flights',
  //   component: flights
  // },
  {
    path: '/flights',
    name: 'flights',
    component: () => import('../views/flights.vue')
  },
  {
    path: '/flightResults',
    name: 'flightResults',
    component: () => import('../views/flightResults.vue')
  },
  {
    path: '/book/:id/:search/:relatedFlightId',
    name: 'book',
    component: () => import('../views/book.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register.vue')
  },
  {
    path: '/verify',
    name: 'verify',
    component: () => import('../views/verify.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => import('../views/resetPassword.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/profile.vue')
  },
  {
    path: '/hotelsResults',
    name: 'hotelsResults',
    component: () => import('../views/hotelsResults.vue')
  },
  {
    path: '/hotels',
    name: 'hotels',
    component: () => import('../views/hotels.vue')
  },
  {
    path: '/hotel/:sessionId/:hotelIndex/:hotelCode',
    name: 'oneHotel',
    component: () => import('../views/oneHotel.vue')
  },
  {
    path: '/bookhotel',
    name: 'hotelBook',
    component: () => import('../views/hotelBook.vue')
  },
  {
    path: '/cars',
    name: 'cars',
    component: () => import('../views/cars.vue')
  },
  {
    path: '/carsResults',
    name: 'carsResults',
    component: () => import('../views/carsResults.vue')
  },
  {
    path: '/carBook/:searchId/:carId',
    name: 'carBook',
    component: () => import('../views/carBook.vue')
  },
  // {
  //   path: '/notifications',
  //   name: 'mail',
  //   component: () => import('../views/mailBox.vue')
  // },
  {
    path: '/trips',
    name: 'trips',
    component: () => import('../views/trips.vue')
  },
  {
    path: '/trip',
    name: 'trip',
    component: () => import('../views/trip.vue')
  }
]
if (process.env.VUE_APP_MODE === 'ats' || process.env.VUE_APP_MODE === 'atsDev') {
  routes.push({
    path: '/',
    name: 'Home',
    component: () => import('../views/flights.vue')
  })
  routes.push({
    path: '*',
    component: empty
  })
} else if (process.env.VUE_APP_MODE === 'adam' || process.env.VUE_APP_MODE === 'adamDev') {
  routes.push({
    path: '/',
    name: 'Home',
    component: () => import('../views/flights.vue')
  })
  routes.push({
    path: '/terms',
    name: 'terms',
    component: () => import('../views/terms.vue')
  })
  routes.push({
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/privacy.vue')
  })
  routes.push({
    path: '*',
    component: empty
  })
} else {
  routes.push({
    path: '/',
    name: 'Home',
    component: home
  })
  routes.push({
    path: '/about',
    name: 'about',
    component: () => import('../views/about.vue')
  })
  routes.push({
    path: '/rewards',
    name: 'rewards',
    component: () => import('../views/rewards.vue')
  })
  routes.push({
    path: '/terms',
    name: 'terms',
    component: () => import('../views/terms.vue')
  })
  routes.push({
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/privacy.vue')
  })
  routes.push({
    path: '/help',
    name: 'help',
    component: () => import('../views/help.vue')
  })
  routes.push({
    path: '*',
    component: empty
  })
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (process.env.VUE_APP_MODE === 'adam' || process.env.VUE_APP_MODE === 'adamDev') {
    if (to.name !== 'login' && to.name !== 'register' && to.name !== 'verify' && to.name !== 'resetPassword' && to.name !== 'terms' && to.name !== 'privacy' && !localStorage.getItem('token')) next({ name: 'login' })
    else next()
  } else {
    next()
  }
})
export default router
